<div class="padding bg-light-grey">
	<div class="flex center">
		<span class="flex center primary hover margin-right" [routerLink]="['/styles']">
			<i class="fa-solid fa-arrow-left margin-right-small"></i>
			Back
		</span>

		Styles
		<i class="fa-solid fa-angle-right padding-right-small padding-left-small grey"></i>
		Style info
	</div>
</div>

<div class="padding page-layout">
	<h4 class="margin-bottom">Style info</h4>

	@if (styleInfo) {
		<section class="flex gap-large info-header">
			<mat-form-field appearance="outline">
				<mat-label>Brand</mat-label>
				<input readonly [value]="styleInfo.brand" matInput />
			</mat-form-field>

			<span class="flex">
				<mat-form-field appearance="outline">
					<mat-label>Collection</mat-label>
					<input readonly [value]="styleInfo.collection" matInput />
				</mat-form-field>
			</span>

			<mat-form-field appearance="outline">
				<mat-label>Category</mat-label>
				<input readonly [value]="styleInfo.category" matInput />
			</mat-form-field>

			<mat-form-field appearance="outline">
				<mat-label>Style Group</mat-label>
				<input readonly [value]="styleInfo.styleGroup" matInput />
			</mat-form-field>

			<mat-form-field appearance="outline">
				<mat-label>Style Code</mat-label>
				<input readonly [value]="styleInfo.styleCode" matInput />
			</mat-form-field>

			<mat-form-field appearance="outline">
				<mat-label>Label</mat-label>
				<input readonly [value]="styleInfo.label" matInput />
			</mat-form-field>
		</section>
	}

	<div class="chip-container">
		@for (element of filtersList; track element) {
			@let label = getLabel(element.id);
			<div (click)="openDialogFilter(element.id)" class="filter-chip" [ngClass]="!label ? '' : 'selected'" [title]="getFullTitleFilter(element.id)">
				{{ element.label + (label ? label : '') }}
				@if (label) {
					<mat-icon (click)="clearFilter($event, element.id)">close</mat-icon>
				}
			</div>
		}
	</div>

	<div class="flex center margin-top">
		<span (click)="selectAllStyles()" class="flex center hover">
			<mat-icon class="margin-right-smallest primary">
				{{ isAllSelected ? 'check_box' : countSelectedStyles() > 0 ? 'indeterminate_check_box' : 'check_box_outline_blank' }}
			</mat-icon>
			@if (countSelectedStyles() > 0) {
				{{ countSelectedStyles() }} selected
			} @else {
				Select all
			}
		</span>

		@if (countSelectedStyles() > 0) {
			<div class="flex margin-left">
				<span class="flex center nowrap primary hover margin-right-small" (click)="downloadImages()">
					<mat-icon>cloud_download</mat-icon>
					Download images
				</span>
			</div>
		}
	</div>

	<bt-loader [loaderId]="loaderId">
		<div class="flex column margin-top">
			<div class="full-width">
				@for (colorRow of colorRows; track colorRow.displayId) {
					<div class="flex column style-accordion" inViewport (inViewportAction)="inViewportAction($event, colorRow)">
						<section class="accordion-header flex between" (click)="toggleDetail(colorRow)">
							<div class="flex">
								<mat-checkbox
									[ngModel]="isColorFullySelected(colorRow)"
									[indeterminate]="isColorIndeterminate(colorRow)"
									(click)="toggleColorSelection(colorRow, $event)">
									{{ colorRow.colorName }}
								</mat-checkbox>

								@if (colorRow.defaultColor) {
									<span class="default-tag">Default color</span>
								} @else {
									<span class="default-button" (click)="setDefaultColor($event, colorRow.colorId)">
										<mat-icon>favorite</mat-icon>
										Set as default
									</span>
								}
							</div>

							<mat-icon>{{ colorRow.disabled ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
						</section>

						<section class="flex column accordion-content" [ngStyle]="{ display: colorRow.disabled ? 'none' : 'block' }">
							@for (sg of colorRow.children; track sg.displayId) {
								<div class="flex column group-block">
									<div class="flex">
										<mat-checkbox [(ngModel)]="sg.selected" (click)="$event.stopPropagation()"></mat-checkbox>
										<span class="flex column details-info">
											Size Group:
											<b>{{ sg.sizeGroupName ?? '—' }}</b>
										</span>
									</div>

									<div class="flex wrap padding-small shots-container">
										@for (shot of sg.shots; track shot.shotId) {
											<div class="flex column shot-border">
												<span class="shot-details">
													@if (shot.imgPath) {
														<img [src]="shot.imgPath" />
													} @else {
														<div class="img-placeholder"></div>
													}
													<section>
														<b>{{ shot.shotTypeName }}</b>
														<span class="flex between">
															<span>{{ shot.aspectRatioCode }}</span>
															<span>Format: {{ shot.mediaFormatCode }}</span>
														</span>
														<span>Utilizzo codificato: {{ shot.codifiedUsedCode }}</span>
														<span>{{ shot.sizeGroupName ?? '—' }}</span>
													</section>
												</span>
												<span class="action-container">
													<span class="upload-button" (click)="openUploadModal(shot)">
														<mat-icon>upload</mat-icon>
														Upload
													</span>

													<span class="hover flex center red">
														<mat-icon>cached</mat-icon>
														Reshoot
													</span>
												</span>
											</div>
										}
									</div>
								</div>
							}
						</section>
					</div>
				}
			</div>
		</div>

		<!-- @if (styleDetails.schema) {
			<div class="flex center margin-bottom-smallest">
				<div class="flex-1">
					<h4>{{ styleDetails.schema.style.fullName }}</h4>
				</div>
			</div>

			<table>
				<tr>
					<th>Selection</th>
					<th>Color</th>
					<th>Size group</th>
					<th>Status</th>
					<th>Shots</th>

					<th>Gallery</th>
					<th>Actions</th>
				</tr>

				@for (item of styleDetails.schema.detailsRows; track item) {
					<tr>
						<td><mat-checkbox class="checkbox" [(ngModel)]="item.selected"></mat-checkbox></td>
						<td>
							{{ item.fullName }}
						</td>
						<td>
							{{ item.sizeGroupName || 'All' }}
						</td>

						<td>
							<div class="flex center nowrap">
								<span class="radius padding-small bg-light-blue border">
									{{ item.photoSessionStatus }}
								</span>
							</div>
						</td>

						<td>
							Approved
							<b>{{ item.approvedShots }}</b>
							of
							<b>{{ item.totalShots }}</b>
						</td>

						<td style="width: 0">
							<div class="nowrap flex gap">
								@for (t of item.shots; track t) {
									<div class="flex column center">
										<span class="grey padding-bottom-small">
											{{ t.shotTypeName ? t.shotTypeCode + ' - ' + t.shotTypeName : t.shotTypeCode }}
										</span>
										<div
											class="thumbnail bg-white relative flex center justify-center"
											[ngClass]="{ border: !t.imgPath }"
											(click)="setActiveShot(item, t, $event)">
											@if (t.imgPath) {
												<img [src]="t.imgPath" />
											}
											@if (t.stateId === shotStatusEnum.Uploaded) {
												<div class="shot-icon">
													<i class="fa fa-cloud-upload margin-small" title="Uploaded"></i>
												</div>
											}
											@if (t.stateId === shotStatusEnum.Approved) {
												<div class="shot-icon approved">
													<i class="fa fa-thumbs-up margin-small" title="Approved"></i>
												</div>
											}
											@if (t.stateId === shotStatusEnum.Rejected) {
												<div class="shot-icon rejected">
													<i class="fa fa-thumbs-down margin-small" title="Rejected"></i>
												</div>
											}
										</div>
									</div>
								}
							</div>
						</td>
						<td>
							<div class="flex center">
								<span class="flex center red hover margin-right" (click)="onReshootRow(item)">
									<i class="fa fa-trash margin-right-smallest"></i>
									Reshoot
								</span>
							</div>
						</td>
					</tr>
				}
			</table>
		} -->
	</bt-loader>

	<!-- @if (currentSidebarType === sidebarTypeEnum.customSidebar && !styleDetails.tmpRow) {
		<bt-sidebar sidebarTitle="Reject shot" (exit)="onExitSidebar()">
			<div class="flex overflow column">
				<div class="flex-0 padding-top-large padding-bottom-large">
					Are you sure you want to
					<b>reject</b>
					selected shot?
				</div>
				<div class="flex-1 padding-bottom-large flex center justify-center sidebar-img-container">
					<img [src]="styleDetails.activeShot.imgPath" />
				</div>
				<div class="flex-0">
					<div class="margin-bottom-small">
						<textarea rows="4" placeholder="Type comment..." class="full-width" cols="50" [(ngModel)]="actionComments"></textarea>
					</div>
				</div>
				<div class="flex-0">
					<button class="full-width warning" [loaderId]="sidebarLoaderId" (click)="reshoot()">
						<i class="fa fa-thumbs-down"></i>
						Reject shot
					</button>
				</div>
			</div>
		</bt-sidebar>
	}
	@if (currentSidebarType === sidebarTypeEnum.customSidebar && styleDetails.tmpRow) {
		<bt-sidebar sidebarTitle="Template details" (exit)="onExitSidebar()">
			<bt-loader [loaderId]="sidebarLoaderId">
				@if (template) {
					<div class="flex column full-height">
						<div class="flex-1 overflow padding-top-large padding-bottom-large padding-left-small padding-right-small">
							<div class="margin-bottom-small">Template name</div>
							<div class="card bold margin-bottom">{{ template.templateName }}</div>
							<div class="margin-bottom-small">Brand</div>
							<div class="card bold margin-bottom">{{ template.brandName }}</div>
							<div class="margin-bottom-small">Category</div>
							<div class="card bold margin-bottom">{{ template.categoryName || '- All categories -' }}</div>
							<div class="margin-bottom-small">Styles</div>
							@if (template.styles.length) {
								<div class="card margin-bottom">
									<b>{{ template.styles[0].styleCode + ' - ' + template.styles[0].styleName }}</b>
									@if (template.styles.length > 1) {
										<span>
											and
											<b>{{ template.styles.length - 1 }}</b>
											other{{ template.styles.length > 2 ? 's' : '' }}
										</span>
									}
								</div>
							} @else {
								<div class="card bold margin-bottom">- All styles -</div>
							}
							<div class="margin-bottom-small">Shot types</div>
							@for (type of template.shotTypes; track type) {
								<div class="card bold margin-bottom-small">{{ type.shotTypeCode }} - {{ type.shotTypeName }}</div>
							}
						</div>
						<div class="flex-0">
							<button class="full-width">
								<i class="fa fa-external-link"></i>
								Go to templates list
							</button>
						</div>
					</div>
				}
			</bt-loader>
		</bt-sidebar>
	}
	@if (currentSidebarType === sidebarTypeEnum.deleteAction) {
		<bt-sidebar sidebarTitle="Reshoot style row" (exit)="onExitSidebar()">
			<bt-loader [loaderId]="sidebarLoaderId">
				<div class="flex column full-height">
					@if (styleDetails.tmpRow) {
						<div class="flex-1 flex center justify-center">
							<div>
								Are you sure you want to
								<b>reshoot</b>
								this style combination {{ styleDetails.schema.style.fullName }} | {{ styleDetails.tmpRow.fullName }}
								{{ styleDetails.tmpRow.sizeGroupId ? ' - ' + styleDetails.tmpRow.sizeGroupName : '' }}?
								<br />
								<br />
								All style combination shots will be deleted.
							</div>
						</div>
					}
					<div class="flex-0">
						<button class="full-width warning" (click)="reshootRow()">
							<i class="fa fa-trash"></i>
							Reshoot style row
						</button>
					</div>
				</div>
			</bt-loader>
		</bt-sidebar>
	} -->
</div>
